import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=31c237fe&scoped=true&"
import script from "./edit.vue?vue&type=script&lang=js&"
export * from "./edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c237fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/baikaifa/Desktop/codes/baikaifa-overwrite-skeleton-webpack-plugin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31c237fe')) {
      api.createRecord('31c237fe', component.options)
    } else {
      api.reload('31c237fe', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=31c237fe&scoped=true&", function () {
      api.rerender('31c237fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "preview/components/edit.vue"
export default component.exports